import { Box, TextField, Typography } from '@mui/material';
import { ChangeEvent, KeyboardEvent, useRef, useState } from 'react';
import { updateWidgetName } from '../state/dashboard/slice';
import { WidgetType } from '../state/dashboard/widget';
import { createValidator, useForm } from '../internal/hooks/useForm';
import { useDashboardHost } from '../context/DashboardHostContext';

import { useDashboardLibraryDispatch, useDashboardLibrarySelector } from '../runtime/DashboardLibraryProvider';
interface NameHandlerComponentProps {
  onClick?: () => void;
  widgetId: number;
  dashboardId: number;
  dashboardElementId: string;
  dashboardType: 'reports' | 'grids';
}

const NameHandlerComponent = ({
  widgetId,
  dashboardId,
  dashboardElementId,
  dashboardType,
}: NameHandlerComponentProps) => {
  const widget = useDashboardLibrarySelector(
    (state) =>
      state.dashboard[dashboardType][dashboardId].widgets[
        dashboardElementId
      ]
  );

  if (!widget) return <div>Widget introuvable</div>;

  return (
    <NameHandlerHelper
      widget={widget}
      dashboardId={dashboardId}
      widgetId={widgetId}
      dashboardElementId={dashboardElementId}
    />
  );
};

const NameHandlerHelper = ({
  widget,
  dashboardId,
  widgetId,
  dashboardElementId,
}: {
  widget: WidgetType;
  dashboardId: number;
  widgetId: number;
  dashboardElementId: string;
}) => {
  const dispatch = useDashboardLibraryDispatch();
  const host = useDashboardHost();
  const [isEditing, setEditing] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const name = widget.elementData.name;

  const defaultValues: { name: string } = {
    name: name,
  };

  const validator = createValidator<{ name: string }>({
    name: [
      (n) =>
        (n && n.length === 0) || !n.trim().length
          ? 'Entrer au moins 4 caractères'
          : undefined,
    ],
  });

  const onRename = async (data: { name: string }) => {
    host.api.dashboard
      .renameWidget(dashboardId, widgetId, {
        name: data.name,
      })
      .then(() => {
      dispatch(
        updateWidgetName({
          gridType: 'grids',
          gridId: dashboardId,
          widgetId: dashboardElementId,
          name: data.name,
        })
      );
    });
  };

  const methods = useForm(defaultValues, validator, onRename);

  const onClickHandler = (event: React.MouseEvent) => {
    if (event.detail === 1) {
      setEditing(true);
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      formRef.current?.requestSubmit();
      setEditing(false);
    } else if (e.key === 'Escape') {
      setEditing(false);
    }
  };

  return (
    <Box display="flex" alignItems="center">
      {isEditing ? (
        <form ref={formRef} onSubmit={methods.onSubmit}>
          <TextField
            defaultValue={name}
            onBlur={() => {
              formRef.current?.requestSubmit();
              setEditing(false);
            }}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              methods.setValue('name', e.target.value)
            }
            onKeyDown={handleKeyDown}
            size="small"
            autoFocus
          />
        </form>
      ) : (
        <Typography onClick={onClickHandler} sx={{ cursor: 'pointer' }}>
          {name}
        </Typography>
      )}
    </Box>
  );
};

export default NameHandlerComponent;
